export type { ActivityIndicatorProps } from '../../types/activity-indicator';
export { ActivityIndicator } from './adapters/inbound/ActivityIndicator';
